import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "common-json-data-model"
    }}>{`Common JSON Data Model`}</h1>
    <p>{`The data models for all JSON content share many common elements. Long strings, unique identifiers, and URLs have been truncated here for legibility.`}</p>
    <pre><code parentName="pre" {...{}}>{`{
    "base": "https://lr.adobe.io/v2/catalogs/9479135e/",
    "id": "a3c679e3",
    "created": "2012-01-03T04:54:32.884643Z",
    "updated": "2012-01-03T04:54:32.884643Z",
    "type": "custom for each type",
    "subtype": "custom for each type",
    "payload": {
        "userCreated": "2012-01-03T04:54:15Z",
        "userUpdated": "2012-01-03T04:54:15Z",
        // custom for each type
    },
    "links": {
        "self": {
            "href": "custom/for/each/type/a3c679e3"
        }
        // additional links custom for each type
    }
}
`}</code></pre>
    <p>{`Unless otherwise noted, all entries at the top level are constructed and provided by the server and can not be modified by clients.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`base`}</inlineCode>{` (URL): Base URL for any relative HREF values in the data. When items are returned in a list, base will typically not be included with each entry.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`id`}</inlineCode>{` (Lightroom-style UUID): Unique Lightroom identifier of this asset. It is usually generated by client on creation but may be generated by the server in some circumstances.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`created`}</inlineCode>{` (ISO 8601 date): Date when asset was first uploaded to the server.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`updated`}</inlineCode>{` (ISO 8601 date): Date when asset was most recently revised on the server.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`type`}</inlineCode>{` (string): Always the same value for a type.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`subtype`}</inlineCode>{` (string): A different set of legal values is defined for each type. Provided by the client on creation. A subtype is always required for types that support it.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`payload`}</inlineCode>{` (optional, table): Metadata about the object provided by the client.`}
        <ul parentName="li">
          <li parentName="ul">{`Values supported within the payload generally differ for each document type.`}</li>
          <li parentName="ul">{`If the payload is completely empty, which is allowed for some types, then it will be omitted.`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`userCreated`}</inlineCode>{` (ISO 8601 date): Date and time when the user created this document on the client side.`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`userUpdated`}</inlineCode>{` (ISO 8601 date): Date and time when the user last updated this document's payload (or other user modifiable data). This should be set at initial creation and updated by a client each time a user makes a change to data within the payload hash. The userUpdated time should not be updated by automated processes (e.g. reverse geocode, etc.).`}</li>
        </ul>
      </li>
      <li parentName="ul"><inlineCode parentName="li">{`links`}</inlineCode>{` (table): Links to related data.`}
        <ul parentName="li">
          <li parentName="ul">{`Each entry is a table containing an `}<inlineCode parentName="li">{`href`}</inlineCode>{` entry with the actual link.`}</li>
          <li parentName="ul">{`All types include the `}<inlineCode parentName="li">{`self`}</inlineCode>{` link.`}</li>
          <li parentName="ul">{`Each type may have other links supported.`}</li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      